<template>
  <div class="text-white product-slide">
    <div class="max-w-md px-8">
      <slot name="title" />
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    last: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.product-slide {
  @apply pt-4 h-full;
}

@media (min-width: 321px) {
  .product-slide {
    padding-top: 20%;
  }
}

@media (min-width: 660px) {
  .product-slide {
    padding-top: 15%;
  }
}
</style>
